import { render, staticRenderFns } from "./ClubInfo.vue?vue&type=template&id=7eed611b&scoped=true&"
import script from "./ClubInfo.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ClubInfo.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ClubInfo.vue?vue&type=style&index=0&id=7eed611b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eed611b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7eed611b')) {
      api.createRecord('7eed611b', component.options)
    } else {
      api.reload('7eed611b', component.options)
    }
    module.hot.accept("./ClubInfo.vue?vue&type=template&id=7eed611b&scoped=true&", function () {
      api.rerender('7eed611b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ClubInfo/ClubInfo.vue"
export default component.exports